import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import RegistrationForm from './components/RegistrationForm';
import BenefitsSection from './components/BenefitsSection';

const Register = () => {
  return (
    <>
      <Helmet>
        <title>Registrati - Vetrine di Macerata</title>
        <meta 
          name="description" 
          content="Crea il tuo account su Vetrine di Macerata per salvare le tue attività preferite, accedere a promozioni esclusive e accumulare cashback" 
        />
      </Helmet>

      <Header onFilterClick={() => {}} />

      <main className="min-h-screen bg-background pt-20 pb-24 lg:pb-8">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-start">
            <div className="order-2 lg:order-1">
              <RegistrationForm />
            </div>

            <div className="order-1 lg:order-2 lg:sticky lg:top-24">
              <BenefitsSection />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Register;